import {useSearchParams} from "react-router-dom";

export function useUpdateSearchParam() {
    const [searchParams, setSearchParams] = useSearchParams();

    return (key: string, value: string) => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set(key, value);
        setSearchParams(newSearchParams);
    };
}